// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"dc03d5bf","296":"f9c86a64","451":"fb19e05d","577":"71a8bd0e","921":"fbab609a","938":"654335d7"}[chunkId] + ".chunk.js";
};